import { HttpMethod, Performer } from '../core'

export class GameEnd extends Performer<void> {
  protected method = HttpMethod.POST
  protected url = '/game-end'
}
